import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ACTIONS from "../../../../redux/action";
import axios from "../../../../shared/axios/axiosProxy.js";
import i18n from "../../../../utils/i18n";
import {
  ACTIVITY_SUBTITLE,
  ACTIVITY_TITLE,
  AgricultureActivityContent,
  ArtActivityContent,
  BeautyActivityContent,
  EtradeActivityContent,
  IndustryActivityLayout,
  ITActivityContent,
  MedicineActivityContent,
  VehicleActivityContent,
} from "./industryActivityContent.jsx";
import {
  industryHasActivityContent,
  isIndustryActivityAnswered,
  isValidSearchID,
  pickIndustryActivitySliceForPersist,
  INDUSTRIES_WITH_ACTIVITY_CONTENT,
} from "../../utils/industryActivity.js";

export {
  INDUSTRIES_WITH_ACTIVITY_CONTENT,
  industryHasActivityContent,
  isIndustryActivityAnswered,
  pickIndustryActivitySliceForPersist,
};

const IndustryActivity = ({ title = ACTIVITY_TITLE, subtitle = ACTIVITY_SUBTITLE } = {}) => {
  const companyStore = useSelector((state) => state.company_store);
  const searchID = useSelector((state) => state.company_store.searchID);
  const dispatch = useDispatch();

  const [vehicleIndustry, setVehicleIndustry] = useState({
    differentialvat: {
      automotivepartstrading: false,
      trading: false,
      service: false,
      other: false,
      otherinput: '',
    },
  });

  const [etradeIndustry, setEtradeIndustry] = useState({
    etradesells: {
      physicalproducts: false,
      services: false,
      intellectualproperty: false,
      other: false,
      otherinput: '',
    },
    etrademultiplecourier: {
      mpl: false,
      gls: false,
      dpd: false,
      sprinter: false,
      expressone: false,
      tntexpress: false,
      fedex: false,
      ups: false,
      dhlexpress: false,
      other: false,
    },
    etrademultipledropoff: {
      foxpost: false,
      alzabox: false,
      packeta: false,
      glscsomagpont: false,
      dpdpickupcsomagpont: false,
      mplpostapont: false,
      other: false,
    },
    etradepayment: {
      transfer: false,
      card: false,
      // benefit: false,
    },
    matchinginvoices: {
      status: '',
      matchingmethod: ''
    },
    deadlinecompliance: {
      status: '',
    },
    actualstore: {
      status: '',
      actualstorecount: null,
    },
    stockhandling: {
      status: '',
    },
  });

  // const [constructionIndustry, setConstructionIndustry] = useState({
  //   constructiontype: {
  //     specializedworks: false,
  //     generalcontracting: false,
  //     constructionprojects: false,
  //     other: false,
  //     otherinput: '',
  //   },
  // });

  const [agricultureIndustry, setAgricultureIndustry] = useState({
    agriculturetype: {
      livestockfarming: false,
      cropproduction: false,
      other: false,
      otherinput: '',
    },
  });

  const [ITIndustry, setITIndustry] = useState({
    ittype: {
      wagereview: false,
      projectwork: false,
      ownprodsoftdev: false,
      other: false,
      otherinput: '',
    }
  });

  const [artIndustry, setArtIndustry] = useState({
    arttype: {
      createartworks: false,
      tradeartworks: false,
      performingartist: false,
      other: false,
      otherinput: '',
    },
  });

  const [beautyIndustry, setBeautyIndustry] = useState({
    beautyproductsales: {
      status: '',
    },
  });

  // const [travelIndustry, setTravelIndustry] = useState({
  //   travelpayment: {
  //     transfer: false,
  //     card: false,
  //     benefit: false,
  //   },
  //   seasonalunits: {
  //     status: '',
  //   },
  //   matchinginvoicestravel: {
  //     status: '',
  //     matchingmethod: ''
  //   },
  //   deadlinecompliancetravel: {
  //     status: '',
  //   },
  // });

  // const [tradeIndustry, setTradeIndustry] = useState({
  //     tradepayment: {
  //         transfer: false,
  //         card: false,
  //         // benefit: false,
  //     },
  // });

  // const [retailIndustry, setRetailIndustry] = useState({
  //   retailpayment: {
  //     transfer: false,
  //     card: false,
  //   },
  //   matchinginvoicesretail: {
  //     status: '',
  //     matchingmethod: ''
  //   },
  //   deadlinecomplianceretail: {
  //     status: '',
  //   },
  // });

  // const [wholesaleIndustry, setWholesaleIndustry] = useState({
  //   wholesalepayment: {
  //     transfer: false,
  //     card: false,
  //   },
  //   matchinginvoiceswholesale: {
  //     status: '',
  //     matchingmethod: ''
  //   },
  //   deadlinecompliancewholesale: {
  //     status: '',
  //   },
  // });

  // const [financeIndustry, setFinanceIndustry] = useState({
  //   complianceauditreview: {
  //     status: '',
  //   },
  // });

  const [medicineIndustry, setMedicineIndustry] = useState({
    medicinetype: {
      doctor: false,
      pharmacy: false,
      nurse: false,
      vet: false,
      other: false,
      otherinput: '',
    },
    medicinepayment: {
      // transfer: false,
      // card: false,
      benefit: false,
    },
  });

  // const [courierIndustry, setCourierIndustry] = useState({
  //   matchinginvoicescourier: {
  //     status: '',
  //     matchingmethod: ''
  //   },
  //   deadlinecompliancecourier: {
  //     status: '',
  //   },
  // });

  useEffect(() => {
    if (companyStore.industryspecifics?.vehicle) {
      setVehicleIndustry(companyStore.industryspecifics.vehicle);
    }
    if (companyStore.industryspecifics?.etrade) {
      setEtradeIndustry(companyStore.industryspecifics.etrade);
    }
    // if (companyStore.industryspecifics?.construction) {
    //   setConstructionIndustry(companyStore.industryspecifics.construction);
    // }
    if (companyStore.industryspecifics?.IT) {
      setITIndustry(companyStore.industryspecifics.IT);
    }
    if (companyStore.industryspecifics?.agriculture) {
      setAgricultureIndustry(companyStore.industryspecifics.agriculture);
    }
    if (companyStore.industryspecifics?.art) {
      setArtIndustry(companyStore.industryspecifics.art);
    }
    if (companyStore.industryspecifics?.beauty) {
      setBeautyIndustry(companyStore.industryspecifics.beauty);
    }
    // if (companyStore.industryspecifics?.travel) {
    //   setTravelIndustry(companyStore.industryspecifics.travel);
    // }
    // if (companyStore.industryspecifics?.retail) {
    //   setRetailIndustry(companyStore.industryspecifics.retail);
    // }
    // if (companyStore.industryspecifics?.wholesale) {
    //   setWholesaleIndustry(companyStore.industryspecifics.wholesale);
    // }
    // if (companyStore.industryspecifics?.finance) {
    //   setFinanceIndustry(companyStore.industryspecifics.finance);
    // }
    if (companyStore.industryspecifics?.medicine) {
      setMedicineIndustry(companyStore.industryspecifics.medicine);
    }
    // if (companyStore.industryspecifics?.courier) {
    //   setCourierIndustry(companyStore.industryspecifics.courier);
    // }
  }, [companyStore.industryspecifics]);

  const handleVehicleChange = useCallback(
    (e) => {
      const { name, checked } = e.target;

      const updatedVehicleIndustry = {
        ...vehicleIndustry,
        differentialvat: {
          ...vehicleIndustry.differentialvat,
          [name]: checked,
          otherinput: name === 'other' && !checked ? '' : vehicleIndustry.differentialvat.otherinput,
        },
      };

      const status =
        updatedVehicleIndustry.differentialvat.automotivepartstrading ||
          updatedVehicleIndustry.differentialvat.trading ||
          updatedVehicleIndustry.differentialvat.service ||
          updatedVehicleIndustry.differentialvat.other
          ? 'true'
          : '';

      setVehicleIndustry((prev) => ({
        ...prev,
        differentialvat: {
          ...updatedVehicleIndustry.differentialvat,
          status: status,
        },
      }));

      dispatch(
        ACTIONS.updateNestedObject({
          stateObject: 'company_store',
          stateObjectID: 'industryspecifics',
          id: 'vehicle',
          data: {
            ...updatedVehicleIndustry,
            differentialvat: {
              ...updatedVehicleIndustry.differentialvat,
              status: status,
            },
          },
        })
      );
    },
    [dispatch, vehicleIndustry]
  );

  const handleVehicleOtherInputChange = useCallback((e) => {
    const { value } = e.target;
    setVehicleIndustry((prev) => ({
      ...prev,
      differentialvat: {
        ...prev.differentialvat,
        otherinput: value,
      },
    }));
  }, []);

  const handleVehicleOtherInputBlur = useCallback(
    (e) => {
      const { value } = e.target;
      setVehicleIndustry((prev) => {
        const data = {
          ...prev,
          differentialvat: {
            ...prev.differentialvat,
            otherinput: value,
          },
        };

        dispatch(
          ACTIONS.updateNestedObject({
            stateObject: 'company_store',
            stateObjectID: 'industryspecifics',
            id: 'vehicle',
            data,
          }),
        );

        return data;
      });
    },
    [dispatch],
  );

  const handleEtradeSellsChange = useCallback(
    (e) => {
      const { name, checked } = e.target;
      setEtradeIndustry((prev) => ({
        ...prev,
        etradesells: {
          ...prev.etradesells,
          [name]: checked,
          otherinput: name === 'other' && !checked ? '' : prev.etradesells.otherinput,
        },
      }));

      dispatch(
        ACTIONS.updateNestedObject({
          stateObject: 'company_store',
          stateObjectID: 'industryspecifics',
          id: 'etrade',
          data: {
            ...etradeIndustry,
            etradesells: {
              ...etradeIndustry.etradesells,
              [name]: checked,
              otherinput: name === 'other' && !checked ? '' : etradeIndustry.etradesells.otherinput,
            },
          },
        })
      );
    },
    [dispatch, etradeIndustry]
  );

  const handleEtradeSellsOtherInputChange = useCallback((e) => {
    const { value } = e.target;
    setEtradeIndustry((prev) => ({
      ...prev,
      etradesells: {
        ...prev.etradesells,
        otherinput: value,
      },
    }));
  }, []);

  const handleEtradeSellsOtherInputBlur = useCallback(
    (e) => {
      const { value } = e.target;
      setEtradeIndustry((prev) => {
        const data = {
          ...prev,
          etradesells: {
            ...prev.etradesells,
            otherinput: value,
          },
        };

        dispatch(
          ACTIONS.updateNestedObject({
            stateObject: 'company_store',
            stateObjectID: 'industryspecifics',
            id: 'etrade',
            data,
          }),
        );

        return data;
      });
    },
    [dispatch],
  );

  // const handleEtradeCourierChange = useCallback(
  //   (e) => {
  //     const { name, checked } = e.target;
  //     setEtradeIndustry((prev) => ({
  //       ...prev,
  //       etrademultiplecourier: {
  //         ...prev.etrademultiplecourier,
  //         [name]: checked,
  //       },
  //     }));

  //     dispatch(
  //       ACTIONS.updateNestedObject({
  //         stateObject: 'company_store',
  //         stateObjectID: 'industryspecifics',
  //         id: 'etrade',
  //         data: {
  //           ...etradeIndustry,
  //           etrademultiplecourier: {
  //             ...etradeIndustry.etrademultiplecourier,
  //             [name]: checked,
  //           },
  //         },
  //       })
  //     );
  //   },
  //   [dispatch, etradeIndustry]
  // );

  // const handleEtradeDropoffChange = useCallback(
  //   (e) => {
  //     const { name, checked } = e.target;
  //     setEtradeIndustry((prev) => ({
  //       ...prev,
  //       etrademultipledropoff: {
  //         ...prev.etrademultipledropoff,
  //         [name]: checked,
  //       },
  //     }));

  //     dispatch(
  //       ACTIONS.updateNestedObject({
  //         stateObject: 'company_store',
  //         stateObjectID: 'industryspecifics',
  //         id: 'etrade',
  //         data: {
  //           ...etradeIndustry,
  //           etrademultipledropoff: {
  //             ...etradeIndustry.etrademultipledropoff,
  //             [name]: checked,
  //           },
  //         },
  //       })
  //     );
  //   },
  //   [dispatch, etradeIndustry]
  // );

  // const handleEtradePaymentChange = useCallback(
  //   (e) => {
  //     const { name, checked } = e.target;
  //     setEtradeIndustry((prev) => ({
  //       ...prev,
  //       etradepayment: {
  //         ...prev.etradepayment,
  //         [name]: checked,
  //       },
  //     }));

  //     dispatch(
  //       ACTIONS.updateNestedObject({
  //         stateObject: 'company_store',
  //         stateObjectID: 'industryspecifics',
  //         id: 'etrade',
  //         data: {
  //           ...etradeIndustry,
  //           etradepayment: {
  //             ...etradeIndustry.etradepayment,
  //             [name]: checked,
  //           },
  //         },
  //       })
  //     );
  //   },
  //   [dispatch, etradeIndustry]
  // );

  // const handleEtradeMatchingInvoiceChange = useCallback(
  //   (e) => {
  //     const { value } = e.target;
  //     const status = value !== '' ? 'true' : '';

  //     setEtradeIndustry((prev) => ({
  //       ...prev,
  //       matchinginvoices: {
  //         ...prev.matchinginvoices,
  //         matchingmethod: value,
  //         status: status,
  //       },
  //     }));

  //     dispatch(
  //       ACTIONS.updateNestedObject({
  //         stateObject: 'company_store',
  //         stateObjectID: 'industryspecifics',
  //         id: 'etrade',
  //         data: {
  //           ...etradeIndustry,
  //           matchinginvoices: {
  //             ...etradeIndustry.matchinginvoices,
  //             matchingmethod: value,
  //             status: status,
  //           },
  //         },
  //       })
  //     );
  //   },
  //   [dispatch, etradeIndustry]
  // );

  // const handleDeadlineComplianceChange = useCallback(
  //   (e) => {
  //     const { value } = e.target;

  //     setEtradeIndustry((prev) => ({
  //       ...prev,
  //       deadlinecompliance: {
  //         status: value,
  //       },
  //     }));

  //     dispatch(
  //       ACTIONS.updateNestedObject({
  //         stateObject: 'company_store',
  //         stateObjectID: 'industryspecifics',
  //         id: 'etrade',
  //         data: {
  //           ...etradeIndustry,
  //           deadlinecompliance: {
  //             status: value,
  //           },
  //         },
  //       })
  //     );
  //   },
  //   [dispatch, etradeIndustry]
  // );

  // const handleActualStoreChange = useCallback(
  //   (e) => {
  //     const { value } = e.target;
  //     let count = null;
  //     if (value === 'true') count = 1;
  //     if (value === 'false') count = '';

  //     setEtradeIndustry((prev) => ({
  //       ...prev,
  //       actualstore: {
  //         status: value,
  //         actualstorecount: count,
  //       },
  //     }));

  //     dispatch(
  //       ACTIONS.updateNestedObject({
  //         stateObject: 'company_store',
  //         stateObjectID: 'industryspecifics',
  //         id: 'etrade',
  //         data: {
  //           ...etradeIndustry,
  //           actualstore: {
  //             status: value,
  //             actualstorecount: count,
  //           },
  //         },
  //       })
  //     );
  //   },
  //   [dispatch, etradeIndustry]
  // );

  // const handleActualStoreCountChange = useCallback(
  //   (e) => {
  //     const { value } = e.target;
  //     const count = Number(value);

  //     if (count <= 0) {
  //       setError(i18n.t('searchflow.physicalstorecounterror'));
  //     } else {
  //       setError('');
  //     }

  //     setEtradeIndustry((prev) => ({
  //       ...prev,
  //       actualstore: {
  //         ...prev.actualstore,
  //         actualstorecount: count,
  //       },
  //     }));

  //     dispatch(
  //       ACTIONS.updateNestedObject({
  //         stateObject: 'company_store',
  //         stateObjectID: 'industryspecifics',
  //         id: 'etrade',
  //         data: {
  //           ...etradeIndustry,
  //           actualstore: {
  //             ...etradeIndustry.actualstore,
  //             actualstorecount: count,
  //           },
  //         },
  //       })
  //     );
  //   },
  //   [dispatch, etradeIndustry]
  // );

  // const handleStockHandlingChange = useCallback(
  //   (e) => {
  //     const { value } = e.target;
  //     setEtradeIndustry((prev) => ({
  //       ...prev,
  //       stockhandling: {
  //         status: value,
  //       },
  //     }));

  //     dispatch(
  //       ACTIONS.updateNestedObject({
  //         stateObject: 'company_store',
  //         stateObjectID: 'industryspecifics',
  //         id: 'etrade',
  //         data: {
  //           ...etradeIndustry,
  //           stockhandling: {
  //             status: value,
  //           },
  //         },
  //       })
  //     );
  //   },
  //   [dispatch, etradeIndustry]
  // );

  // const handleConstructionChange = useCallback(
  //   (e) => {
  //     const { name, checked } = e.target;
  //     setConstructionIndustry((prev) => ({
  //       ...prev,
  //       constructiontype: {
  //         ...prev.constructiontype,
  //         [name]: checked,
  //         otherinput: name === 'other' && !checked ? '' : prev.constructiontype.otherinput,
  //       }
  //     }));

  //     dispatch(
  //       ACTIONS.updateNestedObject({
  //         stateObject: 'company_store',
  //         stateObjectID: 'industryspecifics',
  //         id: 'construction',
  //         data: {
  //           ...constructionIndustry,
  //           constructiontype: {
  //             ...constructionIndustry.constructiontype,
  //             [name]: checked,
  //             otherinput: name === 'other' && !checked ? '' : constructionIndustry.constructiontype.otherinput,
  //           }
  //         },
  //       })
  //     );
  //   },
  //   [dispatch, constructionIndustry]
  // );

  // const handleConstructionOtherInputChange = useCallback(
  //   (e) => {
  //     const { value } = e.target;
  //     setConstructionIndustry((prev) => ({
  //       ...prev,
  //       constructiontype: {
  //         ...prev.constructiontype,
  //         otherinput: value,
  //       }
  //     }));

  //     dispatch(
  //       ACTIONS.updateNestedObject({
  //         stateObject: 'company_store',
  //         stateObjectID: 'industryspecifics',
  //         id: 'construction',
  //         data: {
  //           ...constructionIndustry,
  //           constructiontype: {
  //             ...constructionIndustry.constructiontype,
  //             otherinput: value,
  //           }
  //         },
  //       })
  //     );
  //   },
  //   [dispatch, constructionIndustry]
  // );

  const handleAgricultureChange = useCallback(
    (e) => {
      const { name, checked } = e.target;
      setAgricultureIndustry((prev) => ({
        ...prev,
        agriculturetype: {
          ...prev.agriculturetype,
          [name]: checked,
          otherinput: name === 'other' && !checked ? '' : prev.agriculturetype.otherinput,
        },
      }));

      dispatch(
        ACTIONS.updateNestedObject({
          stateObject: 'company_store',
          stateObjectID: 'industryspecifics',
          id: 'agriculture',
          data: {
            ...agricultureIndustry,
            agriculturetype: {
              ...agricultureIndustry.agriculturetype,
              [name]: checked,
              otherinput: name === 'other' && !checked ? '' : agricultureIndustry.agriculturetype.otherinput,
            },
          },
        })
      );
    },
    [dispatch, agricultureIndustry]
  );

  const handleAgricultureOtherInputChange = useCallback((e) => {
    const { value } = e.target;
    setAgricultureIndustry((prev) => ({
      ...prev,
      agriculturetype: {
        ...prev.agriculturetype,
        otherinput: value,
      },
    }));
  }, []);

  const handleAgricultureOtherInputBlur = useCallback(
    (e) => {
      const { value } = e.target;
      setAgricultureIndustry((prev) => {
        const data = {
          ...prev,
          agriculturetype: {
            ...prev.agriculturetype,
            otherinput: value,
          },
        };

        dispatch(
          ACTIONS.updateNestedObject({
            stateObject: 'company_store',
            stateObjectID: 'industryspecifics',
            id: 'agriculture',
            data,
          }),
        );

        return data;
      });
    },
    [dispatch],
  );

  const handleITChange = useCallback(
    (e) => {
      const { name, checked } = e.target;
      setITIndustry((prev) => {
        const nextIttype =
          name === "wagereviewprojectwork"
            ? {
                ...prev.ittype,
                wagereview: checked,
                projectwork: checked,
              }
            : {
                ...prev.ittype,
                [name]: checked,
                otherinput:
                  name === "other" && !checked ? "" : prev.ittype.otherinput,
              };

        dispatch(
          ACTIONS.updateNestedObject({
            stateObject: 'company_store',
            stateObjectID: 'industryspecifics',
            id: 'IT',
            data: {
              ...prev,
              ittype: nextIttype,
            },
          })
        );

        return { ...prev, ittype: nextIttype };
      });
    },
    [dispatch]
  );

  const handleITOtherInputChange = useCallback((e) => {
    const { value } = e.target;
    setITIndustry((prev) => ({
      ...prev,
      ittype: {
        ...prev.ittype,
        otherinput: value,
      },
    }));
  }, []);

  const handleITOtherInputBlur = useCallback(
    (e) => {
      const { value } = e.target;
      setITIndustry((prev) => {
        const data = {
          ...prev,
          ittype: {
            ...prev.ittype,
            otherinput: value,
          },
        };

        dispatch(
          ACTIONS.updateNestedObject({
            stateObject: 'company_store',
            stateObjectID: 'industryspecifics',
            id: 'IT',
            data,
          }),
        );

        return data;
      });
    },
    [dispatch],
  );

  const handleArtChange = useCallback(
    (e) => {
      const { name, checked } = e.target;
      setArtIndustry((prev) => ({
        ...prev,
        arttype: {
          ...prev.arttype,
          [name]: checked,
          otherinput: name === 'other' && !checked ? '' : prev.arttype.otherinput,
        }
      }));

      dispatch(
        ACTIONS.updateNestedObject({
          stateObject: 'company_store',
          stateObjectID: 'industryspecifics',
          id: 'art',
          data: {
            ...artIndustry,
            arttype: {
              ...artIndustry.arttype,
              [name]: checked,
              otherinput: name === 'other' && !checked ? '' : artIndustry.arttype.otherinput,
            }
          },
        })
      );
    },
    [dispatch, artIndustry]
  );

  const handleArtOtherInputChange = useCallback((e) => {
    const { value } = e.target;
    setArtIndustry((prev) => ({
      ...prev,
      arttype: {
        ...prev.arttype,
        otherinput: value,
      },
    }));
  }, []);

  const handleArtOtherInputBlur = useCallback(
    (e) => {
      const { value } = e.target;
      setArtIndustry((prev) => {
        const data = {
          ...prev,
          arttype: {
            ...prev.arttype,
            otherinput: value,
          },
        };

        dispatch(
          ACTIONS.updateNestedObject({
            stateObject: 'company_store',
            stateObjectID: 'industryspecifics',
            id: 'art',
            data,
          }),
        );

        return data;
      });
    },
    [dispatch],
  );

  const handleBeautyProductSalesChange = useCallback(
    (e) => {
      const { value } = e.target;
      setBeautyIndustry((prev) => ({
        ...prev,
        beautyproductsales: {
          status: value,
        },
      }));

      dispatch(
        ACTIONS.updateNestedObject({
          stateObject: 'company_store',
          stateObjectID: 'industryspecifics',
          id: 'beauty',
          data: {
            ...beautyIndustry,
            beautyproductsales: {
              status: value,
            },
          },
        })
      );
    },
    [dispatch, beautyIndustry]
  );

  // const handleTravelPaymentChange = useCallback(
  //   (e) => {
  //     const { name, checked } = e.target;
  //     setTravelIndustry((prev) => ({
  //       ...prev,
  //       travelpayment: {
  //         ...prev.travelpayment,
  //         [name]: checked,
  //       },
  //     }));

  //     dispatch(
  //       ACTIONS.updateNestedObject({
  //         stateObject: 'company_store',
  //         stateObjectID: 'industryspecifics',
  //         id: 'travel',
  //         data: {
  //           ...travelIndustry,
  //           travelpayment: {
  //             ...travelIndustry.travelpayment,
  //             [name]: checked,
  //           },
  //         },
  //       })
  //     );
  //   },
  //   [dispatch, travelIndustry]
  // );

  // const handleSeasonalUnitsChange = useCallback(
  //   (e) => {
  //     const { value } = e.target;
  //     setTravelIndustry((prev) => ({
  //       ...prev,
  //       seasonalunits: {
  //         status: value,
  //       },
  //     }));

  //     dispatch(
  //       ACTIONS.updateNestedObject({
  //         stateObject: 'company_store',
  //         stateObjectID: 'industryspecifics',
  //         id: 'travel',
  //         data: {
  //           ...travelIndustry,
  //           seasonalunits: {
  //             status: value,
  //           },
  //         },
  //       })
  //     );
  //   },
  //   [dispatch, travelIndustry]
  // );

  // const handleMatchingInvoicesTravelChange = useCallback(
  //   (e) => {
  //     const { value } = e.target;
  //     const status = value !== '' ? 'true' : '';

  //     setTravelIndustry((prev) => ({
  //       ...prev,
  //       matchinginvoicestravel: {
  //         ...prev.matchinginvoicestravel,
  //         matchingmethod: value,
  //         status: status,
  //       },
  //     }));

  //     dispatch(
  //       ACTIONS.updateNestedObject({
  //         stateObject: 'company_store',
  //         stateObjectID: 'industryspecifics',
  //         id: 'travel',
  //         data: {
  //           ...travelIndustry,
  //           matchinginvoicestravel: {
  //             ...travelIndustry.matchinginvoicestravel,
  //             matchingmethod: value,
  //             status: status,
  //           },
  //         },
  //       })
  //     );
  //   },
  //   [dispatch, travelIndustry]
  // );

  // const handleDeadlineComplianceTravelChange = useCallback(
  //   (e) => {
  //     const { value } = e.target;

  //     setTravelIndustry((prev) => ({
  //       ...prev,
  //       deadlinecompliancetravel: {
  //         status: value,
  //       },
  //     }));

  //     dispatch(
  //       ACTIONS.updateNestedObject({
  //         stateObject: 'company_store',
  //         stateObjectID: 'industryspecifics',
  //         id: 'travel',
  //         data: {
  //           ...travelIndustry,
  //           deadlinecompliancetravel: {
  //             status: value,
  //           },
  //         },
  //       })
  //     );
  //   },
  //   [dispatch, travelIndustry]
  // );

  // const handleRetailPaymentChange = useCallback(
  //   (e) => {
  //     const { name, checked } = e.target;
  //     setRetailIndustry((prev) => ({
  //       ...prev,
  //       retailpayment: {
  //         ...prev.retailpayment,
  //         [name]: checked,
  //       },
  //     }));

  //     dispatch(
  //       ACTIONS.updateNestedObject({
  //         stateObject: 'company_store',
  //         stateObjectID: 'industryspecifics',
  //         id: 'retail',
  //         data: {
  //           ...retailIndustry,
  //           retailpayment: {
  //             ...retailIndustry.retailpayment,
  //             [name]: checked,
  //           },
  //         },
  //       })
  //     );
  //   },
  //   [dispatch, retailIndustry]
  // );

  // const handleWholesalePaymentChange = useCallback(
  //   (e) => {
  //     const { name, checked } = e.target;
  //     setWholesaleIndustry((prev) => ({
  //       ...prev,
  //       wholesalepayment: {
  //         ...prev.wholesalepayment,
  //         [name]: checked,
  //       },
  //     }));

  //     dispatch(
  //       ACTIONS.updateNestedObject({
  //         stateObject: 'company_store',
  //         stateObjectID: 'industryspecifics',
  //         id: 'wholesale',
  //         data: {
  //           ...wholesaleIndustry,
  //           wholesalepayment: {
  //             ...wholesaleIndustry.wholesalepayment,
  //             [name]: checked,
  //           },
  //         },
  //       })
  //     );
  //   },
  //   [dispatch, wholesaleIndustry]
  // );

  // const handleFinanceIndustryChange = useCallback(
  //   (e) => {
  //     const { value } = e.target;
  //     setFinanceIndustry((prev) => ({
  //       ...prev,
  //       complianceauditreview: {
  //         status: value,
  //       },
  //     }));

  //     dispatch(
  //       ACTIONS.updateNestedObject({
  //         stateObject: 'company_store',
  //         stateObjectID: 'industryspecifics',
  //         id: 'finance',
  //         data: {
  //           ...financeIndustry,
  //           complianceauditreview: {
  //             status: value,
  //           },
  //         },
  //       })
  //     );
  //   },
  //   [dispatch, financeIndustry]
  // );

  const handleMedicineChange = useCallback(
    (e) => {
      const { name, checked } = e.target;
      setMedicineIndustry((prev) => ({
        ...prev,
        medicinetype: {
          ...prev.medicinetype,
          [name]: checked,
          otherinput: name === 'other' && !checked ? '' : prev.medicinetype.otherinput,
        }
      }));

      dispatch(
        ACTIONS.updateNestedObject({
          stateObject: 'company_store',
          stateObjectID: 'industryspecifics',
          id: 'medicine',
          data: {
            ...medicineIndustry,
            medicinetype: {
              ...medicineIndustry.medicinetype,
              [name]: checked,
              otherinput: name === 'other' && !checked ? '' : medicineIndustry.medicinetype.otherinput,
            }
          },
        })
      );
    },
    [dispatch, medicineIndustry]
  );

  // const handleMedicinePaymentChange = useCallback(
  //   (e) => {
  //     const { name, checked } = e.target;
  //     setMedicineIndustry((prev) => ({
  //       ...prev,
  //       medicinepayment: {
  //         ...prev.medicinepayment,
  //         [name]: checked,
  //       },
  //     }));

  //     dispatch(
  //       ACTIONS.updateNestedObject({
  //         stateObject: 'company_store',
  //         stateObjectID: 'industryspecifics',
  //         id: 'medicine',
  //         data: {
  //           ...medicineIndustry,
  //           medicinepayment: {
  //             ...medicineIndustry.medicinepayment,
  //             [name]: checked,
  //           },
  //         },
  //       })
  //     );
  //   },
  //   [dispatch, medicineIndustry]
  // );

  const handleMedicineOtherInputChange = useCallback((e) => {
    const { value } = e.target;
    setMedicineIndustry((prev) => ({
      ...prev,
      medicinetype: {
        ...prev.medicinetype,
        otherinput: value,
      },
    }));
  }, []);

  const handleMedicineOtherInputBlur = useCallback(
    (e) => {
      const { value } = e.target;
      setMedicineIndustry((prev) => {
        const data = {
          ...prev,
          medicinetype: {
            ...prev.medicinetype,
            otherinput: value,
          },
        };

        dispatch(
          ACTIONS.updateNestedObject({
            stateObject: 'company_store',
            stateObjectID: 'industryspecifics',
            id: 'medicine',
            data,
          }),
        );

        return data;
      });
    },
    [dispatch],
  );

  // const handleMatchingInvoicesRetailChange = useCallback(
  //   (e) => {
  //     const { value } = e.target;
  //     const status = value !== '' ? 'true' : '';

  //     setRetailIndustry((prev) => ({
  //       ...prev,
  //       matchinginvoicesretail: {
  //         ...prev.matchinginvoicesretail,
  //         matchingmethod: value,
  //         status: status,
  //       },
  //     }));

  //     dispatch(
  //       ACTIONS.updateNestedObject({
  //         stateObject: 'company_store',
  //         stateObjectID: 'industryspecifics',
  //         id: 'retail',
  //         data: {
  //           ...retailIndustry,
  //           matchinginvoicesretail: {
  //             ...retailIndustry.matchinginvoicesretail,
  //             matchingmethod: value,
  //             status: status,
  //           },
  //         },
  //       })
  //     );
  //   },
  //   [dispatch, retailIndustry]
  // );

  // const handleDeadlineComplianceRetailChange = useCallback(
  //   (e) => {
  //     const { value } = e.target;

  //     setRetailIndustry((prev) => ({
  //       ...prev,
  //       deadlinecomplianceretail: {
  //         status: value,
  //       },
  //     }));

  //     dispatch(
  //       ACTIONS.updateNestedObject({
  //         stateObject: 'company_store',
  //         stateObjectID: 'industryspecifics',
  //         id: 'retail',
  //         data: {
  //           ...retailIndustry,
  //           deadlinecomplianceretail: {
  //             status: value,
  //           },
  //         },
  //       })
  //     );
  //   },
  //   [dispatch, retailIndustry]
  // );

  // const handleMatchingInvoicesWholesaleChange = useCallback(
  //   (e) => {
  //     const { value } = e.target;
  //     const status = value !== '' ? 'true' : '';

  //     setWholesaleIndustry((prev) => ({
  //       ...prev,
  //       matchinginvoiceswholesale: {
  //         ...prev.matchinginvoiceswholesale,
  //         matchingmethod: value,
  //         status: status,
  //       },
  //     }));

  //     dispatch(
  //       ACTIONS.updateNestedObject({
  //         stateObject: 'company_store',
  //         stateObjectID: 'industryspecifics',
  //         id: 'wholesale',
  //         data: {
  //           ...wholesaleIndustry,
  //           matchinginvoiceswholesale: {
  //             ...wholesaleIndustry.matchinginvoiceswholesale,
  //             matchingmethod: value,
  //             status: status,
  //           },
  //         },
  //       })
  //     );
  //   },
  //   [dispatch, wholesaleIndustry]
  // );

  // const handleDeadlineComplianceWholesaleChange = useCallback(
  //   (e) => {
  //     const { value } = e.target;

  //     setWholesaleIndustry((prev) => ({
  //       ...prev,
  //       deadlinecompliancewholesale: {
  //         status: value,
  //       },
  //     }));

  //     dispatch(
  //       ACTIONS.updateNestedObject({
  //         stateObject: 'company_store',
  //         stateObjectID: 'industryspecifics',
  //         id: 'wholesale',
  //         data: {
  //           ...wholesaleIndustry,
  //           deadlinecompliancewholesale: {
  //             status: value,
  //           },
  //         },
  //       })
  //     );
  //   },
  //   [dispatch, wholesaleIndustry]
  // );

  // const handleMatchingInvoicesCourierChange = useCallback(
  //   (e) => {
  //     const { value } = e.target;
  //     const status = value !== '' ? 'true' : '';

  //     setCourierIndustry((prev) => ({
  //       ...prev,
  //       matchinginvoicescourier: {
  //         ...prev.matchinginvoicescourier,
  //         matchingmethod: value,
  //         status: status,
  //       },
  //     }));

  //     dispatch(
  //       ACTIONS.updateNestedObject({
  //         stateObject: 'company_store',
  //         stateObjectID: 'industryspecifics',
  //         id: 'courier',
  //         data: {
  //           ...courierIndustry,
  //           matchinginvoicescourier: {
  //             ...courierIndustry.matchinginvoicescourier,
  //             matchingmethod: value,
  //             status: status,
  //           },
  //         },
  //       })
  //     );
  //   },
  //   [dispatch, courierIndustry]
  // );

  // const handleDeadlineComplianceCourierChange = useCallback(
  //   (e) => {
  //     const { value } = e.target;

  //     setCourierIndustry((prev) => ({
  //       ...prev,
  //       deadlinecompliancecourier: {
  //         status: value,
  //       },
  //     }));

  //     dispatch(
  //       ACTIONS.updateNestedObject({
  //         stateObject: 'company_store',
  //         stateObjectID: 'industryspecifics',
  //         id: 'courier',
  //         data: {
  //           ...courierIndustry,
  //           deadlinecompliancecourier: {
  //             status: value,
  //           },
  //         },
  //       })
  //     );
  //   },
  //   [dispatch, courierIndustry]
  // );

  useEffect(() => {
    const industry = companyStore.industry;
    if (!industryHasActivityContent(industry)) {
      return;
    }

    const slice = companyStore.industryspecifics?.[industry];
    const persistedSlice = pickIndustryActivitySliceForPersist(industry, slice);
    if (!isValidSearchID(searchID) || !persistedSlice) {
      return;
    }

    axios
      .patch(
        `/api/search/${searchID}`,
        { industryspecifics: { [industry]: persistedSlice } },
        { headers: { 'Content-Type': 'application/json' } },
      )
      .catch((error) => {
        console.error(
          'Error saving industryspecifics to search:',
          error.response?.data || error.message,
        );
      });
  }, [companyStore.industry, companyStore.industryspecifics, searchID]);

  const industry = companyStore.industry;

  // SearchFlow B uses one shared title for every industry. Beauty is a yes/no question
  // that the shared title doesn't fit, so it shows its own question, as in SearchFlow A.
  // Flows for a business that doesn't exist yet (reg/kftReg/vaf) pass the future-tense
  // title, so they get the future-tense beauty question.
  const beautyQuestion =
    industry !== 'beauty'
      ? null
      : title === ACTIVITY_TITLE
        ? i18n.t('searchflow.beautyindustryquestion')
        : title === i18n.t('searchflow.regactivitytitle')
          ? i18n.t('searchflow.regbeautyindustryquestion')
          : null;

  return (
    <IndustryActivityLayout
      title={beautyQuestion || title}
      subtitle={beautyQuestion ? '' : subtitle}
    >
      {industry === 'vehicle' && (
        <VehicleActivityContent
          vehicleIndustry={vehicleIndustry}
          handleVehicleChange={handleVehicleChange}
          handleVehicleOtherInputChange={handleVehicleOtherInputChange}
          handleVehicleOtherInputBlur={handleVehicleOtherInputBlur}
        />
      )}
      {industry === 'etrade' && (
        <EtradeActivityContent
          etradeIndustry={etradeIndustry}
          handleEtradeSellsChange={handleEtradeSellsChange}
          handleEtradeSellsOtherInputChange={handleEtradeSellsOtherInputChange}
          handleEtradeSellsOtherInputBlur={handleEtradeSellsOtherInputBlur}
        />
      )}
      {industry === "IT" && (
        <ITActivityContent
          ITIndustry={ITIndustry}
          handleITChange={handleITChange}
          handleITOtherInputChange={handleITOtherInputChange}
          handleITOtherInputBlur={handleITOtherInputBlur}
        />
      )}
      {industry === 'agriculture' && (
        <AgricultureActivityContent
          agricultureIndustry={agricultureIndustry}
          handleAgricultureChange={handleAgricultureChange}
          handleAgricultureOtherInputChange={handleAgricultureOtherInputChange}
          handleAgricultureOtherInputBlur={handleAgricultureOtherInputBlur}
        />
      )}
      {industry === 'art' && (
        <ArtActivityContent
          artIndustry={artIndustry}
          handleArtChange={handleArtChange}
          handleArtOtherInputChange={handleArtOtherInputChange}
          handleArtOtherInputBlur={handleArtOtherInputBlur}
        />
      )}
      {industry === 'beauty' && (
        <BeautyActivityContent
          beautyIndustry={beautyIndustry}
          handleBeautyProductSalesChange={handleBeautyProductSalesChange}
        />
      )}
      {industry === 'medicine' && (
        <MedicineActivityContent
          medicineIndustry={medicineIndustry}
          handleMedicineChange={handleMedicineChange}
          handleMedicineOtherInputChange={handleMedicineOtherInputChange}
          handleMedicineOtherInputBlur={handleMedicineOtherInputBlur}
        />
      )}
    </IndustryActivityLayout>
  );
};

export default IndustryActivity;
